import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'עידו לוי',
  role: 'מייסד ומעצב ראשי',
  gradient: 'from-[#7c5cfc] to-[#22d3ee]'
}, {
  name: 'מאיה כהן',
  role: 'מפתחת Full Stack',
  gradient: 'from-[#ff2d8a] to-[#7c5cfc]'
}, {
  name: 'רון אהרון',
  role: 'מנהל פרויקטים',
  gradient: 'from-[#22d3ee] to-[#10b981]'
}];
export function Team() {
  return <section id="team" className="py-32 relative z-20 bg-[#0a0a0f]" data-id="element-142">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-143">
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-144">
          <h2 className="text-5xl md:text-7xl font-display font-black text-white mb-6" data-id="element-145">
            האנשים <span className="text-gradient" data-id="element-146">מאחורי הפיקסלים</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-147">
          {team.map((member, index) => <motion.div key={index} className="text-center group" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} data-id="element-148">
              <div className="relative w-48 h-48 mx-auto mb-8" data-id="element-149">
                <div className={`absolute inset-0 rounded-full bg-gradient-to-br ${member.gradient} opacity-80 group-hover:scale-110 transition-transform duration-500`} data-id="element-150" />
                <div className="absolute inset-1 rounded-full bg-[#0a0a0f]" data-id="element-151" />
                {/* Placeholder for photo */}
                <div className={`absolute inset-2 rounded-full bg-gradient-to-br ${member.gradient} opacity-50`} data-id="element-152" />
              </div>
              <h3 className="text-2xl font-display font-bold text-white mb-2" data-id="element-153">
                {member.name}
              </h3>
              <p className="text-[#22d3ee] font-medium" data-id="element-154">{member.role}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}